<!-- 
Listing of transactions made against an invoice.

These are retrieved from SAP and are for information only - we don't have any
business logic that looks at them.
-->
<template>
  <span>
    <v-card class="v-card--flat">
      <our-table-busy-indicator :show="loading"/>
      <v-data-table 
        :headers="headers" 
        :items="transactions"
        :total-items="transactions.length"
        hide-actions
        default-no-data-text="No transactions yet"
        style="border: 1px solid #f0f0f0;"
      >
        <template slot="items" slot-scope="props">
          <tr class="noselect">
            <td>{{ props.item.sapDocumentIdentifier }}</td>
            <td>{{ props.item.transactionType }}</td>
            <td>{{ props.item.postingDate | compactDate }}</td>
            <td>{{ props.item.amount | currency }}</td>
            <td>{{ props.item.status }}</td>
            <td :class="getReferenceClass(props.item.reference)">{{ props.item.reference }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </span>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import * as action from "@/store/invoices/action-types";

export default {
  mixins: [filterMixins],
  props: {
    invoiceId: {
      type: Number,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        { text: "SAP document ID", sortable: false },
        { text: "Type", sortable: false },
        { text: "Posting date", sortable: false },
        { text: "Amount", sortable: false },
        { text: "Status", sortable: false },
        { text: "Reference", sortable: false }
      ];
    },
    state() {
      return this.$store.state.invoices.transactions.find(t => t.invoiceId == this.invoiceId);
    },
    loaded() {
      return this.state ? this.state.loaded : false;
    },
    loading() {
      return this.state ? this.state.loading : false;
    },
    transactions() {
      return this.loaded ? this.state.data : [];
    }
  },
  watch: {
    invoiceId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      const hasChanged =
        !this.state || (!this.state.loaded && !this.state.loading) || this.state.invoiceId != this.invoiceId;
      if (hasChanged) {
        this.$store.dispatch(action.GET_TRANSACTIONS, this.invoiceId);
      }
    },
    getReferenceClass(reference) {
      return reference == "OVERPAYMENT" ? "reference-overpayment" : "";
    }
  }
};
</script>

<style lang="scss">
.reference-overpayment {
  color: red;
}
</style>